import ClipboardJS from 'clipboard';

new ClipboardJS('.js-copyToClipboard');
